import { dayjs } from '@utils/date'
import { LiveEventScheduledAt } from './liveEvent'

export const formatScheduledAt = ({
  date,
  format,
  template,
  replacer,
}: LiveEventScheduledAt): string => {
  const formatted = dayjs(date).format(format)
  return template.replace(replacer, formatted)
}

export const formatScheduledAtShort = ({
  date,
  format,
}: LiveEventScheduledAt): string => dayjs(date).format(format)

export interface LiveEventTransformedCompetitor {
  name: string
  position: number
  time: string
}
